module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hE0sn2/tc-custom/9781497656000.jpg?1734405277465",
      "alt": "This image is the cover for the book Hard Target, OPSIG Team Black"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hard Target, OPSIG Team Black\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("After an assassination attempt on the president-elect, the OPSIG team is on the hunt in this “terrific thriller” from the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author (Lee Child).")]), _c('br'), _c('br'), _c('i', [_vm._v("Hard Target")]), _vm._v(" by Alan Jacobson is a ticking time bomb that will keep you clinging to the edge of your seat . . . and turning the pages.  "), _c('br'), _c('br'), _vm._v(" An explosion pulverizes the president-elect’s helicopter on election night. It soon becomes clear that the group behind the assassination attempt possesses far greater reach than the FBI Joint Terrorism Task Force has yet encountered—and a plot so deeply interwoven in the country’s fabric that it threatens to upend America’s political system.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alan Jacobson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alan Jacobson is the national bestselling author of the critically acclaimed FBI profiler Karen Vail and OPSIG Team Black series. Jacobson’s years of extensive research and training while embedded with federal and local law enforcement agencies have influenced him both personally and professionally, and have helped shape the stories he tells and the diverse characters that populate his novels.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0